<template>
<div id="Login">
    <div class="container">
        
        <div class="py-5 text-center">
            <h2>Login</h2>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <FormulateForm
                    name="login"
                    @submit="submitLogin"
                    v-model="formData"
                    class="login-form"
                >
                    <FormulateInput
                    name="email"
                    label="Email"
                    validation="required|email"
                    input-class="form-control"
                    />
                    <FormulateInput
                    name="password"
                    label="Password"
                    type="password"
                    validation="required"
                    input-class="form-control"
                    />
                    <FormulateErrors />
                    <div class="actions">
                    <FormulateInput
                        label="Login"
                        type="submit"
                        input-class="btn btn-success btn-lg mt-3"
                    />
                    </div>
                    
                </FormulateForm>            
            </div>
        </div>
    </div>
</div>
</template>

<script>
import moment from "moment";
import JQuery from "jquery";
import axios from "axios";

window.$ = JQuery;
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

export default {
    name: "Login",
    data () {
        return {
        formData: {}
        }
    },
    watch: {

    },
    methods: {
        submitLogin (data) {
            axios
            .post('/api/auth/local', {
                identifier: data.email,
                password: data.password,
            })
            .then(response => {
                // Handle success.
                console.log('Well done!');
                console.log('User profile', response.data.user);
                console.log('User token', response.data.jwt);
                this.$store.commit('setUserJWT',response.data.jwt)
                localStorage.userJWT = response.data.jwt


                this.$router.push({
                    name: 'quotes',
                    params: {
                        saveSuccess: true,
                        message: 'Successfully logged in'
                    }
                })
            })
            .catch(error => {
                const errors = {
                    formErrors: ['Incorrect Email or Password']
                }
                this.$formulate.handle(errors, 'login')
                this.$root.handleError(error.response)
            });
        },
        reset () {
        this.$formulate.reset('login')
        }
    },
    async mounted() {

        console.log(this.$store.state.userJWT);
    },
};
</script>

<style scoped>

</style>
